import type { DashboardRowType } from '@shared/types/Dashboard';

export const profileVersusPageDashboardRows: DashboardRowType[] = [
  {
    items: [
      {
        rowSpan: 2,
        colSpan: 3,
        elementId: 6,
      },
    ],
  },
  {
    items: [
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 1,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 0,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 7,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 2,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 3,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 4,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 5,
      },
    ],
  },
];
